<template>
  <v-container id="docForm" class="max-width">
    <!-- first card -->
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Lipa Pole Pole Details</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/lipa-pole-pole">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <!-- printer div -->
        <div id="print" v-show="showPrinterDiv" style>

          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
            <div style="text-align: center;">
              <br />

              <span style="font-size: 16px;">Date: {{ record.CreatedAt | date }}</span>
              <br />
            </div>
          </div>

          <br />

          <span>-------------------------------------------------------</span>


          <div v-for="(item, index) in receiptHeaders" :key="'header-' + index"
            style="font-size: 16px; text-align: center;">
            <div>
              <span style="text-align: center;"> {{ item.rowText }}</span>

            </div>
          </div>

          <span>-------------------------------------------------------</span>

          <div>
            <span class="style-16">Order#: {{ record.DocNum }}</span>
            <br />
            <span style="font-size: 16px;">Customer Name: {{ record.customerName }}</span>
            <br />
            <span style="font-size: 16px;">Phone Number: {{ record.customerPhone }}</span>
          </div>

          <br />


          <div>
            <span style="font-size: 14px;">Items Ordered</span>
          </div>

          <div
            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
            <span style="width: 33.33%; text-align: left; padding-left: 2px;">Price</span>

            <span style="width: 23.33%; text-align: center;">Quantity</span>

            <span style="width: 43.33%; text-align: left; padding-right: 2px;">Total</span>
          </div>

          <div v-for="(item, index) in orderItems" :key="'item-' + (item.LineNum || item.id || index)"
            style="font-size: 14px;">
            <div style="width: 100%; text-align: left; padding-left: 2px; font-weight: bold">{{ item.name }}</div>
            <div style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between;">
              <span style="width: 33.33%; text-align: left; padding-left: 2px;">{{ item.Price | currency }}</span>

              <span style="width: 23.33%; text-align: center;">x {{ item.Quantity }}</span>

              <span style="width: 43.33%; text-align: left; padding-right: 2px;">{{ item.LineTotal | currency }}</span>
            </div>
          </div><br>

          <!-- payments -->
          <div>
            <span style="font-size: 14px;">Payments</span>
          </div>

          <div
            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
            <span style="width: 33.33%; text-align: left; padding-left: 2px;">Account</span>

            <span style="width: 23.33%; text-align: center;">Amount</span>

            <span style="width: 43.33%; text-align: left; padding-right: 2px;">Date</span>
          </div>

          <div v-for="(item, index) in payments" :key="'payment-' + (item.id || index)" style="font-size: 16px;">
            <div style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between;">
              <span style="width: 33.33%; text-align: left; padding-left: 2px;">{{ item.Account.Name }}</span>

              <span style="width: 23.33%; text-align: center;"> {{ item.Amount | currency }}</span>

              <span style="width: 43.33%; text-align: left; padding-right: 2px;">{{ item.date | date }}</span>
            </div>
          </div><br><br>
          <!-- end -->

          <div
            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
            <span style="width: 30%; text-align: left; padding-left: 2px;">Total Amount: </span>

            <span style="width: 20%; text-align: left; padding-right: 20px;">{{ record.DocTotal | currency }}</span>
          </div>
          <!--  -->

          <div
            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
            <span style="width: 30%; text-align: left; padding-left: 2px;">Amount Paid: </span>

            <span style="width: 20%; text-align: left; padding-right: 20px;">{{ totalPayments | currency }}</span>
          </div>
          <!--  -->

          <div
            style="font-size: 14px; white-space: nowrap; display: flex; justify-content: space-between; font-weight: bold;">
            <span style="width: 30%; text-align: left; padding-left: 2px;">Outstanding Balance: </span>

            <span style="width: 20%; text-align: left; padding-right: 20px;">{{ (record.DocTotal - totalPayments) |
              currency }}</span>
          </div>
          <!--  -->

          <span>-------------------------------------------------------</span>

          <div v-for="(item, index) in receiptFooters" :key="'footer-' + index"
            style="font-size: 16px; text-align: center;">
            <div>
              <span style="text-align: center;"> {{ item.rowText }}</span>

            </div>
          </div>


        </div>

        <!-- end -->

        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" md="7">
                <span class="style-16" style="font-weight: bold">Order Details</span>
                <br />
                <br />
                <span class="style-16">Customer Name: {{ record.Customer && record.Customer.Name }}</span>
                <br />

                <span class="style-16">Phone Number: {{ record.Customer && record.Customer.PhoneNumber }}</span>
              </v-col>

              <!-- <v-col cols="12">
                <v-btn text color="accent" @click="paymentDialog = true">
                  <v-icon left>mdi-plus</v-icon>Add Payment
                </v-btn>
              </v-col> -->
            </v-row>
          </v-col>

          <v-col cols="12" md="2">
            <v-btn color="primary" @click="print" text>
              <v-icon left>mdi-printer</v-icon>Print Receipt
            </v-btn>
          </v-col>

          <v-col cols="12" md="4">
            <v-row class="justify-end">
              <v-col cols="12" md="7">
                <span class="style-16" style="float: right">Order No#: {{ record.DocNum }}</span>
                <br />
                <span class="style-16" style="float: right">Total: {{ record.DocTotal &&
                  record.DocTotal.toLocaleString() }}.00</span>
                <br />
                <br />
                <span class="style-16" style="float: right">Date: {{ record.CreatedAt | date }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of first card -->


    <!-- no bp card -->
    <v-card class="mt-4">
      <v-card-text>
        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-btn text @click="addItemDialog = true" color="accent" class="mb-3">
              <v-icon left>mdi-plus</v-icon>Add Item To List
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-data-table light dense :items-per-page="1000" :headers="headers" :items="orderItems" item-key="LineNum"
              hide-default-footer disable-sort :mobile-breakpoint="0">
              <template v-slot:item.index="{ index }">
                <span>{{ index + 1 }}</span>
              </template>

              <template v-slot:item.Name="{ item }">
                {{ item }}
                <!-- autocomplete -->
                <v-text-field style="width: 350px" single-line dense readonly v-model="item.Name"></v-text-field>
              </template>

              <template v-slot:item.UomEntry="{ item }">
                <v-text-field filled outlined readonly dense value="Unit(s)"
                  v-if="item.ManualStatus == 'Y'"></v-text-field>

                <span v-else>Uom Unit</span>
              </template>

              <template v-slot:item.Price="{ item }">
                <span>{{ item.Price.toLocaleString() }}.00</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                <span>{{ item.Quantity }}</span>
              </template>

              <template v-slot:item.PendingQuantity="{ item }">{{ item.Quantity - (parseFloat(item.QuantityDelivered) +
                parseFloat(item.QuantityRemaining)) }}</template>

              <template v-slot:item.LineTotal="{ item }">
                <span>{{ item.DisplayTotal }}.00</span>
              </template>

              <template v-slot:item.edit="{ item }">
                <v-btn icon @click="openEditDialog(item)" color="primary">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>

              <template v-slot:item.delete="{ item }">
                <v-btn icon color="error" @click="openDeleteDialog(item)" :disabled="orderItems.length <= 1">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of card -->

    <!-- payment card -->
    <v-card class="mt-4">
      <v-card-text>
        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12" v-show="balance > 0">
            <v-btn @click.native="paymentDialog = true" class="float-right" color="accent"
              text><v-icon>mdi-plus</v-icon>Add
              Payment</v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table light dense :items-per-page="1000" :headers="paymentHeaders" :items="payments"
              item-key="LineNum" hide-default-footer disable-sort :mobile-breakpoint="0">
              <template v-slot:item.index="{ index }">
                <span>{{ index + 1 }}</span>
              </template>

              <template v-slot:item.Amount="{ item }">
                <span>{{ item.Amount | currency }}</span>
              </template>


              <template v-slot:item.date="{ item }">{{ item.date | date }}</template>

              <template v-slot:item.edit="{ item }">
                <v-btn icon @click="openEditPaymentDialog(item)">
                  <v-icon color="primary">mdi-pencil</v-icon>
                </v-btn>
              </template>

              <!-- <template v-slot:item.delete="{ item }">
                <v-btn icon color="red">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template> -->
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of card -->

    <!-- Compact Financial Summary -->
    <v-card class="mt-4" elevation="1">
      <v-card-text class="py-3">
        <v-row dense align="center">
          <v-col cols="12" md="8">
            <v-row dense>
              <v-col cols="12" sm="4" class="d-flex align-center">
                <v-icon class="mr-2 blue--text">mdi-receipt</v-icon>
                <span class="body-1 font-weight-medium mr-2">Total Bill:</span>
                <span class="body-1 font-weight-bold blue--text">
                  {{ record.DocTotal ? record.DocTotal.toLocaleString() : '0' }}.00
                </span>
              </v-col>
              <v-col cols="12" sm="4" class="d-flex align-center">
                <v-icon class="mr-2 green--text">mdi-cash</v-icon>
                <span class="body-1 font-weight-medium mr-2">Total Paid:</span>
                <span class="body-1 font-weight-bold green--text">
                  {{ totalPayments ? totalPayments.toLocaleString() : '0' }}.00
                </span>
              </v-col>
              <v-col cols="12" sm="4" class="d-flex align-center">
                <v-icon class="mr-2" :class="balance > 0 ? 'orange--text' : 'grey--text'">
                  {{ balance > 0 ? 'mdi-alert-circle' : 'mdi-check-circle' }}
                </v-icon>
                <span class="body-1 font-weight-medium mr-2" :class="balance > 0 ? 'orange--text' : 'grey--text'">
                  Balance
                </span>
                <span class="body-1 font-weight-bold" :class="balance > 0 ? 'orange--text' : 'grey--text'">
                  {{ Math.abs(balance).toLocaleString() }}.00
                </span>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="4" v-if="record.DocTotal > 0">
            <div class="d-flex align-center">
              <span class="caption mr-2">Progress:</span>
              <v-progress-linear :value="(totalPayments / record.DocTotal) * 100" height="6" rounded
                :color="balance <= 0 ? 'green' : 'primary'" class="flex-grow-1"></v-progress-linear>
              <span class="caption ml-2 font-weight-medium">
                {{ Math.round((totalPayments / record.DocTotal) * 100) }}%
              </span>
            </div>
          </v-col>
        </v-row>

        <v-row v-show="balance <= 0">
          <v-col cols="12" md="3">
            <v-text-field label="User Pin" v-model="pinNo" outlined dense autocomplete="on" prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'"
              @click:append="showPassword = !showPassword"></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-btn color="accent" @click="completeSale" :loading="loader">
              <v-icon left>mdi-check</v-icon> Complete Sale
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- End Compact Financial Summary -->

    <!-- Payment dialog -->
    <v-dialog v-model="paymentDialog" max-width="750">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Record Payment</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="paymentDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-form ref="lipaPaymentForm" v-model="valid" :lazy-validation="lazy">
              <v-row>
                <v-col cols="12" xs="12" md="6">
                  <v-autocomplete :rules="inputRules" autocomplete="off" hide-details dense outlined
                    v-model="paymentItem.AccountId" :items="accounts" label="Account" item-text="Name"
                    item-value="id"></v-autocomplete>
                </v-col>

                <v-col cols="12" xs="12" md="6">
                  <v-text-field :rules="inputRules" autocomplete="off" type="text" v-model="paymentItem.AmountPaid"
                    label="Amount Paid" outlined dense></v-text-field>
                </v-col>

                <v-col cols="12" xs="12" md="6">
                  <v-text-field autocomplete="off" type="text" v-model="paymentItem.RefNo" label="Ref / No" outlined
                    dense></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <span class="style-16">Date: {{ date }}</span>
                </v-col>

                <v-col cols="12">
                  <v-btn color="primary" @click="receivePayment" :loading="loader">
                    <v-icon left>mdi-plus</v-icon>Add Payment
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of payment modal-->

    <!-- Edit Payment dialog -->
    <v-dialog v-model="editPaymentDialog" max-width="750">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Edit Payment Deposit</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="editPaymentDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-form ref="lipaPaymentForm" v-model="valid" :lazy-validation="lazy">
              <v-row>
                <v-col cols="12" xs="12" md="6">
                  <v-autocomplete :rules="inputRules" autocomplete="off" hide-details dense outlined
                    v-model="editPaymentItem.o_a_c_t_s_id" :items="accounts" label="Account" item-text="Name"
                    item-value="id"></v-autocomplete>
                </v-col>

                <v-col cols="12" xs="12" md="6">
                  <v-text-field :rules="inputRules" autocomplete="off" type="text" v-model="editPaymentItem.Amount"
                    label="Amount Paid" outlined dense></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <DatePicker @date="setPaymentDate" :myDate="EditedPaymentDate" :title="`Date`" ref="dateRef">
                  </DatePicker>
                </v-col>

                <v-col cols="12">
                  <v-btn color="primary" @click="editPayment" :loading="loader">
                    <v-icon left>mdi-plus</v-icon>Edit Payment
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of edit payment modal-->

    <!-- Edit Item Dialog -->
    <v-dialog v-model="editDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Edit Item</v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-form ref="editForm" v-model="editValid">
              <v-row>
                <v-col cols="12">
                  <v-text-field label="Product Name" v-model="editItem.name" readonly outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field label="Quantity" v-model.number="editItem.Quantity" type="number" :rules="quantityRules"
                    outlined dense></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field label="Price" v-model.number="editItem.Price" type="number" :rules="priceRules" outlined
                    dense></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Line Total"
                    :value="(editItem.Quantity * editItem.Price).toLocaleString() + '.00'" readonly outlined
                    dense></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="editDialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveEditItem" :loading="editLoader">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end of edit modal -->



    <!-- Delete Item Dialog -->
    <v-dialog v-model="deleteDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Confirm Delete</v-card-title>
        <v-card-text>
          <p><strong>Are you sure you want to delete this item?</strong></p>
          <v-divider class="my-3"></v-divider>
          <div v-if="selectedItem" class="text-body-1">
            <p class="mb-2"><strong>Product:</strong> <span class="font-weight-medium">{{ selectedItem.name }}</span>
            </p>
            <p class="mb-2"><strong>Quantity:</strong> <span class="font-weight-medium">{{ selectedItem.Quantity
                }}</span>
            </p>
            <p class="mb-2"><strong>Price:</strong> <span class="font-weight-medium">{{
              selectedItem.Price.toLocaleString()
                }}.00</span></p>
            <p class="mb-2"><strong>Total:</strong> <span class="font-weight-medium">{{ selectedItem.DisplayTotal
                }}.00</span></p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" @click="confirmDeleteItem" :loading="deleteLoader">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end of delete modal -->

    <!-- Add Item Dialog -->
    <v-dialog v-model="addItemDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="secondary" flat>
          <v-toolbar-title>Add Item To A Deposit Order</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="addItemDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row dense>
              <v-col cols="12" xs="12" md="12">
                <v-autocomplete autocomplete="off" v-model="select" :isloading="isLoading" :items="products"
                  :search-input.sync="searchProducts" @change="setTransferItem(select)" item-text="Name" item-value="id"
                  cache-items class="mt-2" flat hide-no-data hide-details label="Search Product" outlined
                  dense></v-autocomplete>
              </v-col>

              <v-col cols="12" xs="12" md="12" v-if="transferItem.ProductName">
                <div class="mb-2">
                  <span class="caption grey--text">Product Name</span>
                  <div class="body-2 font-weight-medium">{{ transferItem.ProductName }}</div>
                </div>
              </v-col>

              <v-col cols="12" xs="12" md="4">
                <v-text-field autocomplete="off" type="number" v-model="transferItem.TransferQty" label="Quantity"
                  outlined dense @input="qtyChanged(transferItem)"></v-text-field>
              </v-col>

              <v-col cols="6" xs="6" md="4">
                <v-text-field autocomplete="off" type="text" name="goodsReceiptUom" filled outlined readonly dense
                  value="Unit(s)" v-if="transferItem.ManualStatus == 'Y'"></v-text-field>
                <v-autocomplete autocomplete="off" v-else dense outlined single-line v-model="transferItem.UomEntry"
                  :items="transferItem.ugp1" label="UOM" item-text="UomName" item-value="UomId"
                  @change="uomChanged(transferItem)"></v-autocomplete>
              </v-col>

              <v-col cols="6" xs="6" md="4">
                <v-text-field label="Selling Price" v-model.number="transferItem.currentPrice" type="number" outlined
                  dense @input="priceChanged"></v-text-field>
              </v-col>


              <v-col cols="12" xs="12" md="6">
                <div class="mb-2">
                  <span class="caption grey--text">Line Total</span>
                  <div class="body-1 font-weight-bold primary--text">{{ calculateTransferItemTotal().toLocaleString()
                  }}.00
                  </div>
                </div>
              </v-col>

              <v-col cols="12">
                <v-btn color="primary" @click="addNewLipaRecord" :loading="loader" class="float-right">
                  <v-icon left>mdi-plus</v-icon>Add To List
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of add item modal -->

    <v-divider class="mt-2"></v-divider>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  props: {
    docTitle: {
      type: String
    },
    backUrl: {
      type: String
    },
    noTitle: {
      type: String
    },
    initial: {
      type: Object,
      required: true
    }
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
    totalPayments() {
      let total = 0;
      if (typeof this.payments != "undefined" && this.payments.length > 0) {
        return this.payments
          .map(item => {
            let amount = 0;
            if (item.Amount) {
              amount = parseFloat(item.Amount);
            }

            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    balance() {
      return this.record.DocTotal - this.totalPayments;
    }
  },
  data: () => ({
    showPassword: false,
    pinNo: null,
    EditedPaymentDate: null,
    transferItem: {},
    showPrinterDiv: false,
    receiptHeaders: [],
    receiptFooters: [],
    select: null,
    record: {},
    valid: false,
    lazy: false,
    paymentItem: {},
    paymentDialog: false,
    inputRules: [v => !!v || "Required"],
    DocNum: null,
    loader: false,
    copyObj: null,
    copyData: [{ Name: "Goods Receipt", id: 12 }],
    orderItems: [],
    payments: [],
    accounts: [],
    pageItems: 100,
    date: new Date().toISOString().substr(0, 10),
    editDialog: false,
    deleteDialog: false,
    editItem: {},
    selectedItem: null,
    editValid: false,
    editLoader: false,
    deleteLoader: false,
    quantityRules: [
      v => !!v || 'Quantity is required',
      v => v > 0 || 'Quantity must be greater than 0'
    ],
    priceRules: [
      v => !!v || 'Price is required',
      v => v > 0 || 'Price must be greater than 0'
    ],
    editPaymentItem: {},
    editPaymentDialog: false,
    addItemDialog: false,
    addItemValid: false,
    addItemLoader: false,
    newItem: {},
    products: [],
    searchProducts: '',
    isLoading: false,
    productRules: [
      v => !!v || 'Product is required'
    ],
    headers: [
      { text: "NO:", value: "index" },
      { text: "Product", value: "name" },
      { text: "Quantity", value: "Quantity" },
      { text: "Price", value: "Price" },
      { text: "Total", value: "LineTotal" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" }
    ],
    paymentHeaders: [
      { text: "Account", value: "Account.Name" },
      { text: "Amount", value: "Amount" },
      { text: "Date", value: "date" },
      { text: "Edit", value: "edit" },
    ]
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    },
    searchProducts(val) {
      if (val && val !== this.select && this.querySelections(val)) {
        this.querySelections(val);
      }
    }
  },
  methods: {
    print() {
      // Get the HTML content you want to print
      const content = document.getElementById("print").innerHTML;

      // Open a new print window
      const printWindow = window.open(
        "",
        "",
        "left=0,top=0,width=100,height=auto,toolbar=0,scrollbars=0,status=0"
      );

      // Write the HTML to the print window, including the content
      printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body {
            width: 80mm;
            margin: 0 auto;
          }
          @page {
            size: auto;  /* auto is the current printer page size */
            margin: 0mm; /* this affects the margin in the printer settings */
          }
        </style>
      </head>
      <body onload="window.print(); window.close();">${content}</body>
    </html>
  `);

      printWindow.document.close();
    },
    addNewLipaRecord() {
      if (!this.transferItem.productId) {
        this.$refs.snackbar.show("Please select a product", "red");
        return;
      }
      if (!this.transferItem.TransferQty || this.transferItem.TransferQty <= 0) {
        this.$refs.snackbar.show("Please enter a valid quantity", "red");
        return;
      }
      if (!this.transferItem.currentPrice || this.transferItem.currentPrice <= 0) {
        this.$refs.snackbar.show("Please enter a valid price", "red");
        return;
      }

      this.addItemToList();
    },
    receivePayment() {
      if (!this.$refs.lipaPaymentForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      var data = {
        CustomerId: parseInt(this.record.Customer.id),
        DepositId: parseInt(this.record.id),
        AccountId: parseInt(this.paymentItem.AccountId),
        AmountPaid: parseFloat(this.paymentItem.AmountPaid),
        DocDate: this.date,
        RefNo: this.paymentItem.RefNo,
        SubsriberId: parseInt(localStorage.getItem("subscriber_id"))
      };

      var url = "/lipa-pole-pole-payment";

      const self = this;
      this.loader = false;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            location.reload();
          }

          if (res.ResultCode == 1500) {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        })
        .finally(() => {
          location.reload();
        });
    },
    editPayment() {
      if (this.EditedPaymentDate == null || this.EditedPaymentDate == '') {
        this.$refs.snackbar.show("Please select a valid date", "red");
        return;
      }

      var data = {
        PaymentId: parseInt(this.editPaymentItem.id),
        AccountId: parseInt(this.editPaymentItem.o_a_c_t_s_id),
        AmountPaid: parseFloat(this.editPaymentItem.Amount),
        DocDate: this.EditedPaymentDate,
      };

      var url = "/edit-lipa-pole-pole-payment";

      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            location.reload();
          }

          if (res.ResultCode == 1500) {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          row.DisplayTotal = row.LineTotal.toLocaleString();
          products.push(row);
        }
        this.orderItems = products;
      }

      if (val.payments) {
        this.payments = val.payments;
      }
    },
    setDate(date) {
      this.date = date;
    },
    setPaymentDate(date) {
      this.EditedPaymentDate = date;
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReceiptHeaders() {
      this.$store.commit("btnLoader", false);
      const self = this;
      this.$store
        .dispatch("get", `/get-receipt-headers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.receiptHeaders = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getReceiptFooters() {
      this.$store.commit("btnLoader", false);
      const self = this;
      this.$store
        .dispatch("get", `/get-receipt-footers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.receiptFooters = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/12`)
        .then(res => {
          if (res.ResultCode == 1200) {
            if (self.docCreate == true) {
              self.record = {
                ...self.record,
                DocNum: res.ResponseData
              };
            }
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    openEditDialog(item) {
      this.editItem = { ...item };
      this.editDialog = true;
    },
    openEditPaymentDialog(item) {
      this.editPaymentItem = { ...item };
      console.log(item, ' payment item to edit ');
      this.editPaymentDialog = true;
    },
    completeSale() {

      if (!this.pinNo) {
        this.$refs.snackbar.show("Please enter user pin to complete sale", "red");
        return;
      }

      this.loader = true;

      const data = {
        invoiceId: this.record.id,
        pinNo: this.pinNo
      };

      this.$store
        .dispatch("post", { url: "/complete-deposit-order", data })
        .then(res => {
          if (res.ResultCode == 1200) {
            this.$router.push("/lipa-pole-pole");
          } else {
            this.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveEditItem() {
      if (!this.$refs.editForm.validate()) {
        return;
      }

      this.editLoader = true;

      const lineTotal = this.editItem.Price * this.editItem.Quantity;

      const data = {
        quantity: this.editItem.Quantity,
        price: this.editItem.Price,
        lineTotal: lineTotal
      };

      const url = `/lipa-pole-pole-row/${this.editItem.id}`;

      this.$store
        .dispatch("put", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // Find the original item and update it locally
            const index = this.orderItems.findIndex(i => i.id === this.editItem.id);
            if (index !== -1) {
              this.orderItems[index].Quantity = this.editItem.Quantity;
              this.orderItems[index].Price = this.editItem.Price;
              this.orderItems[index].LineTotal = lineTotal;
              this.orderItems[index].DisplayTotal = lineTotal.toLocaleString();

              // Update record total
              this.updateRecordTotal();
            }

            this.editLoader = false;
            this.editDialog = false;
            this.$refs.snackbar.show("Item updated successfully", "green");
          } else {
            this.editLoader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.editLoader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    openDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    confirmDeleteItem() {
      if (this.orderItems.length <= 1) {
        this.$refs.snackbar.show("Cannot delete the last remaining item", "red");
        return;
      }

      if (!this.selectedItem || !this.selectedItem.id) {
        this.$refs.snackbar.show("Invalid item selected for deletion", "red");
        return;
      }

      this.deleteLoader = true;

      const url = `/lipa-pole-pole-row/${this.selectedItem.id}`;

      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            // Remove the item from local list
            const index = this.orderItems.findIndex(i => i.id === this.selectedItem.id);
            if (index !== -1) {
              this.orderItems.splice(index, 1);
            }

            // Update record total with the value returned from server
            if (res.ResponseData.docTotal !== undefined) {
              this.record.DocTotal = res.ResponseData.docTotal;
            } else {
              this.updateRecordTotal();
            }

            this.deleteLoader = false;
            this.deleteDialog = false;
            this.selectedItem = null;
            this.$refs.snackbar.show("Item deleted successfully", "green");
          } else {
            this.deleteLoader = false;
            this.$refs.snackbar.show(res.ResultDesc || "Failed to delete item", "red");
          }
        })
        .catch(err => {
          this.deleteLoader = false;
          this.$refs.snackbar.show("Error deleting item: " + err, "red");
        });
    },
    updateRecordTotal() {
      const total = this.orderItems.reduce((sum, item) => {
        return sum + (item.LineTotal || 0);
      }, 0);
      this.record.DocTotal = total;
    },
    setTransferItem(id) {

      const self = this;
      var storeId = this.activeStore;


      var url = `/product-inventory/${id}/${storeId}`;

      // fetch the product from database
      this.$store
        .dispatch("get", url)
        .then(res => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;
            console.log(product, " produ t on lipa pole pole edit ");
            let currentItem = {};
            const LineNum = new Date().getTime();
            currentItem.refNo = "";
            currentItem.LineNum = LineNum;
            currentItem.Quantity = null;
            currentItem.ManualStatus = product.HasUom == 0 ? "Y" : "N";
            currentItem.productId = id;
            if (self.IsDistributor == "N") {
              currentItem.ItemCode = "";
            }

            if (self.IsDistributor == "Y") {
              if (product.SupermarketCode == "") {
                currentItem.ItemCode = product.ItemCode;
              }

              if (product.SupermarketCode != "") {
                currentItem.ItemCode = product.SupermarketCode;
              }

            }

            currentItem.ProductName = product.Name;
            currentItem.AvailableQty = product.AvailableQty;
            currentItem.StockBal = product.AvailableQty;
            // end

            if (product.HasUom === 0) {
              // check if manual yes and assign
              var sellingPrice = product.sellingPrice;
              var buyingPrice = product.buyingPrice;
              currentItem.BuyingPrice = buyingPrice;
              currentItem.SellingPrice = sellingPrice;
              currentItem.currentPrice = sellingPrice;
              currentItem.uomEntryName = "Pc(s)";
              currentItem.UomEntry = 0;
              // end of manual yes
            }

            // start of manual No status
            if (product.HasUom === 1) {
              let ugp1Data = Array.isArray(product.ugp1) ? product.ugp1 : [];
              const ugp1Record = ugp1Data.find(record => {
                return record.UomEntry === product.SUoMEntry;
              });
              currentItem.ugp1 = ugp1Data;
              currentItem.UomEntry = product.SUoMEntry;
              currentItem.uomEntryName = ugp1Record.UomName;
              currentItem.BuyingPrice = ugp1Record.BuyingPrice;
              currentItem.SellingPrice = ugp1Record.SellingPrice;
              currentItem.currentPrice = ugp1Record.SellingPrice; // Set the current price for display
            }

            self.transferItem = { ...self.transferItem, ...currentItem };

            this.select = null;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    calculateTransferItemTotal() {
      if (this.transferItem.TransferQty && this.transferItem.currentPrice) {
        return parseFloat(this.transferItem.TransferQty) * parseFloat(this.transferItem.currentPrice);
      }
      return 0;
    },
    qtyChanged() {
      // This method will trigger reactivity for the total calculation
      // The total is calculated via the computed method calculateTransferItemTotal
      this.$forceUpdate();
    },
    priceChanged() {
      // This method will trigger reactivity for the total calculation when price changes
      // The total is calculated via the computed method calculateTransferItemTotal
      this.$forceUpdate();
    },
    uomChanged(data) {
      let uomEntryName = "";

      // uom name
      let ugp1 = data.ugp1;
      let ugp1Record = {};
      if (data.ManualStatus == "N") {
        ugp1Record = ugp1.find(record => {
          return record.UomId === data.UomEntry;
        });
        if (ugp1Record) {
          uomEntryName = ugp1Record.UomName;
          // Update prices based on UOM selection
          this.transferItem = {
            ...this.transferItem,
            currentPrice: ugp1Record.SellingPrice,
            SellingPrice: ugp1Record.SellingPrice,
            BuyingPrice: ugp1Record.BuyingPrice,
            uomEntryName: uomEntryName,
            UomEntry: data.UomEntry
          };
        }
      } else {
        uomEntryName = "Unit(s)";
        this.transferItem = {
          ...this.transferItem,
          uomEntryName: uomEntryName
        };
      }
    },
    closeAddItemDialog() {
      this.addItemDialog = false;
      this.transferItem = {};
      this.select = null;
    },
    addItemToList() {
      this.loader = true;

      const lineTotal = this.calculateTransferItemTotal();
      const data = {
        lipaPolePoleId: this.record.id,
        productId: this.transferItem.productId,
        quantity: parseFloat(this.transferItem.TransferQty),
        price: parseFloat(this.transferItem.currentPrice),
        lineTotal: parseFloat(lineTotal),
        uomEntry: this.transferItem.UomEntry || null
      };

      console.log(data);

      const url = `/lipa-pole-pole-row`;

      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            // Add the new item to the local list
            const newOrderItem = {
              id: res.ResponseData.id,
              name: this.transferItem.ProductName,
              Quantity: parseFloat(this.transferItem.TransferQty),
              Price: parseFloat(this.transferItem.currentPrice),
              LineTotal: parseFloat(lineTotal),
              DisplayTotal: lineTotal.toLocaleString(),
              UomEntry: this.transferItem.UomEntry
            };


            this.orderItems.push(newOrderItem);

            // Update record total with the value returned from server
            if (res.ResponseData.docTotal !== undefined) {
              this.record.DocTotal = res.ResponseData.docTotal;
            } else {
              this.updateRecordTotal();
            }

            this.loader = false;
            this.closeAddItemDialog();
            this.$refs.snackbar.show("Item added successfully", "green");
          } else {
            this.loader = false;
            this.$refs.snackbar.show(res.ResultDesc || "Failed to add item", "red");
          }
        })
        .catch(err => {
          this.loader = false;
          this.$refs.snackbar.show("Error adding item: " + err, "red");
        });
    },
    getProducts() {
      this.isLoading = true;
      this.$store
        .dispatch("get", `/products`)
        .then(res => {
          if (res.ResultCode == 1200) {
            this.products = Array.isArray(res.ResponseData) ? res.ResponseData : [];
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    querySelections(searchText) {
      const self = this;
      const url = "/products/search";
      const data = {
        SearchText: String(searchText),
        CustomerId: 0
      };
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200 && res.ResponseData != null) {
            self.products = Array.isArray(res.ResponseData) ? res.ResponseData : [];
          }
        })
        .catch(() => { });
    }
  },
  created() {
    Promise.all([this.getAccounts(), this.getDocNum(), this.getReceiptHeaders(), this.getReceiptFooters(), this.getProducts()]);
  }
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>